export enum FieldType {
    Editable = "Editable",
    Unavailable = "Unavailable",
    Readonly = "Readonly",
    FixedValues = "FixedValues"
}